module.exports = __webpack_public_path__ + "media/images/athletes/2412-2302f9f6bde524b0d92f78d4c405d7a0.png";